export const appointmentJourneyStepTypeEnum = {
  customerIdentification: 1,
  serviceTypes: 2,
  location: 3,
  service: 4,
  dateAndTime: 5,
  customerDetails: 6,
  setAppointment: 7,
  success: 8,
  OTP: 9,
  newCustomer: 10,
  cancellingOption: 11,
  question: 12,
  0: 'newStep',
  1: 'customerIdentification',
  2: 'serviceTypes',
  3: 'location',
  4: 'service',
  5: 'dateAndTime',
  6: 'customerDetails',
  7: 'setAppointment',
  8: 'success',
  9: 'OTP',
  10: 'newCustomer',
  11: 'cancellingOption',
  12: 'question'
}

export const rescheduleJourneyStepTypeEnum = {
  customerIdentification: 13,
  appointmentDetails: 14,
  cancellingOption: 15,
  question: 16,
  dateAndTime: 17,
  setAppointment: 18,
  success: 19,
  cancellingOption1: 20,
  OTP: 21,
  13: 'customerIdentification',
  14: 'appointmentDetails',
  15: 'cancellingOption',
  16: 'question',
  17: 'dateAndTime',
  18: 'setAppointment',
  19: 'success',
  20: 'cancellingOption1',
  21: 'OTP',
}

export const quickRescheduleJourneyStepTypeEnum = {
  customerIdentification: 22,
  verificationOTP: 23,
  errorPage: 24,
  question: 25,
  dateAndTime: 26,
  setAppointment: 27,
  success: 28,
  cancellingOption: 29,
  22: 'customerIdentification',
  23: 'verificationOTP',
  24: 'errorPage',
  25: 'question',
  26: 'dateAndTime',
  27: 'setAppointment',
  28: 'success',
  39: 'cancellingOption'
}

export const linkType =
{
  1: 'link',
  2: 'urlShortUniqueCode',
  3: 'journeyShortUniqueCode',
  'link': 1,
  'urlShortUniqueCode': 2,
  'journeyShortUniqueCode': 3
}

export const propertyTypes = {
  newCustomerIdType: 1,
  verification: 2,
  idType: 3,
  locations: 4,
  serviceTypes: 5,
  appointmentTypes: 6,
  services: 7,
  date: 8,
  rangeTime: 9,
  time: 10,
  summary: 11,
  success: 12,
  label: 13,
  warning: 14,
  information: 15,
  header: 16,
  customerProperty: 17,
  customProperty: 18,
  customerDetails: 19,
  cancelAppointment: 20,
  cancelAppointmentMessage: 21,
  singleSelection: 22,
  appointmentDetails: 23,
  link: 24,
  errorMessages: 25,
  successMessagesReschedule: 26,
  multiSelection: 27,
  freeText: 28,
  defaultQuestion: 29,
  stickyLabel: 9999,
  1: 'newCustomerIdType',
  2: 'verification',
  3: 'idType',
  4: 'locations',
  5: 'serviceTypes',
  6: 'appointmentTypes',
  7: 'services',
  8: 'date',
  9: 'rangeTime',
  10: 'time',
  11: 'summary',
  12: 'success',
  13: 'label',
  14: 'warning',
  15: 'information',
  16: 'header',
  17: 'customerProperty',
  18: 'customProperty',
  19: 'customerDetails',
  20: 'cancelAppointment',
  21: 'cancelAppointmentMessage',
  22: 'singleSelection',
  23: 'appointmentDetails',
  24: 'link',
  25: 'errorMessages',
  26: 'successMessagesReschedule',
  27: 'multiSelection',
  28: 'freeText',
  29: 'defaultQuestion',
  9999: 'stickyLabel'
}
